<div class="account-container">
  <h3>Profile Management and Security Settings</h3>
  <div class="top-messages">
    @for (address of unverifiedAddress; track address) {
      <div class="ui warning message">
        You email address: {{address}} is not verified, please go to <a routerLink="/verification">verification page</a> to send email with verification code.
      </div>
    }
  </div>
  <div class="setting-cards">
    @if (enableProfile) {
      <div class="profile-card ui segment">
        <h4>Profile Settings</h4>
        <app-messages [messages]="flow?.ui?.messages"></app-messages>
        <app-flow [flow]="flow" only="profile" (submit)="onSubmit($event)" [hideGlobalMessages]="true"></app-flow>
      </div>
    }
    @if (enablePassword) {
      <div class="password-card ui segment">
        <h4>Change Password</h4>
        <app-messages [messages]="flow?.ui?.messages"></app-messages>
        <app-flow [flow]="flow" only="password" (submit)="onSubmit($event)" [hideGlobalMessages]="true"></app-flow>
      </div>
    }
    @if (enableOidc) {
      <div class="oidc-card ui segment">
        <h4>Manage Social Sign In</h4>
        <app-messages [messages]="flow?.ui?.messages"></app-messages>
        <app-flow [flow]="flow" only="oidc" (submit)="onSubmit($event)" [hideGlobalMessages]="true"></app-flow>
      </div>
    }
    <!--    <div class="lookup-secret-card ui segment">-->
    <!--      <h4>lookup_secret</h4>-->
  <!--    </div>-->
  <!--    <div class="totp-card ui segment">-->
  <!--      <h4>totp</h4>-->
<!--    </div>-->
<!--    <div class="webauthn-card ui segment">-->
<!--      <h4>webauthn</h4>-->
<!--    </div>-->
<!--    <div class="passkey-card ui segment">-->
<!--      <h4>passkey</h4>-->
<!--    </div>-->
</div>
</div>
